import type { ButtonHTMLAttributes, ReactElement, ReactNode } from 'react';

export interface IconButtonProps extends Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'className' | 'aria-label'
> {
  /** Required: an icon-only control is unusable without a name. */
  label: string;
  children: ReactNode;
}

export function IconButton({
  label,
  children,
  type = 'button',
  ...rest
}: IconButtonProps): ReactElement {
  return (
    <button {...rest} type={type} className="icon-btn" aria-label={label} title={label}>
      {children}
    </button>
  );
}
